import React, { useEffect, useRef } from 'react'
import type { IStoreSelectedFacet } from '@generated/graphql'

import SelectedFilters from '../SelectedFilters'
import Facets from '../Facets'
import '../../filter.scss'
import type { FacetsProps } from '../../types/components/Facets'
import handleClickOutside from '../../utils/handleClickOutside'

interface FilterContainerDesktopProps extends FacetsProps {
  selectedFacetsFilter: IStoreSelectedFacet[]
  setSelectedFacets: React.Dispatch<React.SetStateAction<IStoreSelectedFacet[]>>
  filterNewTypeStatus?: boolean
  defaultFacets?: Array<{
    key: string
    value: string
  }>
  quiz?: boolean
  setIndicesExpanded: React.Dispatch<React.SetStateAction<Set<number>>>
}

function FilterContainerDesktop({
  selectedFacets,
  selectedFacetsFilter,
  cleanUpFacets,
  filteredFacets,
  indicesExpanded,
  onApply,
  onFacetChange,
  onAccordionChange,
  onAccordionItemMount,
  minPriceSelected,
  maxPriceSelected,
  setMinPriceSelected,
  setMaxPriceSelected,
  setSelectedFacets,
  testId = 'store-filter',
  filterNewTypeStatus,
  defaultFacets,
  quiz,
  setIndicesExpanded,
}: FilterContainerDesktopProps) {
  const featureParam = !filterNewTypeStatus ? 'assembly' : undefined

  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) =>
      handleClickOutside({ targetRef, setIndicesExpanded, event })

    document.addEventListener('click', handleDocumentClick)

    return () => document.removeEventListener('click', handleDocumentClick)
  }, [targetRef, setIndicesExpanded])

  return (
    <div>
      <Facets
        testId={`desktop-${testId}`}
        selectedFacets={selectedFacetsFilter}
        cleanUpFacets={cleanUpFacets}
        filteredFacets={filteredFacets}
        indicesExpanded={indicesExpanded}
        onApply={onApply}
        onFacetChange={onFacetChange}
        onAccordionChange={onAccordionChange}
        onAccordionItemMount={onAccordionItemMount}
        minPriceSelected={minPriceSelected}
        maxPriceSelected={maxPriceSelected}
        setMinPriceSelected={setMinPriceSelected}
        setMaxPriceSelected={setMaxPriceSelected}
        targetRef={targetRef}
      />

      {selectedFacets?.length > 0 && (
        <SelectedFilters
          selectedFacets={selectedFacetsFilter}
          applyFilters={setSelectedFacets}
          feature={featureParam}
          cleanUpFacets={cleanUpFacets}
          defaultFacets={defaultFacets}
          quiz={quiz}
        />
      )}
    </div>
  )
}

export default FilterContainerDesktop
